'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _uniq = require('lodash/uniq');

var _uniq2 = _interopRequireDefault(_uniq);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (perCharacterBitEntrophy, passwordUnderTest) {
    var optimalBitEntrophy = perCharacterBitEntrophy * passwordUnderTest.length;
    var efficiency = Math.log((0, _uniq2.default)(passwordUnderTest).length) / Math.log(passwordUnderTest.length);
    return Math.round(optimalBitEntrophy * efficiency * 100) / 100;
};
//# sourceMappingURL=efficiency.js.map